import React from 'react'
import View from './view'

const LocationMap = ({ ...props }) => {
    return <View {...props} />
}

export default LocationMap